import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { REPORTING_ADMINISTRATOR_PERMISSION } from '@config/global-constants';
import { environment } from '@environments/environment';
import { log_out, show_company_selector } from '@rpt-ngrx/actions/session.action';
import { selectCompanies, selectCompanyId, selectPermissions, selectUser } from '@rpt-ngrx/selectors/session.selector';
import { IUser } from '@shared/types';
import { ICompany, IUserPermissions } from '@shared/types/session';
import { XUXDrawerSidebarService } from '@xenial-ux/services/xux-drawer-sidebar.service';

@Component({
    selector: 'dm-main-header',
    styleUrls: ['main-header.style.scss'],
    templateUrl: 'main-header.template.html',
})
export class MainHeaderComponent implements OnInit, OnDestroy {
    public buildVersion: string = environment.version;
    public companies: any[] = [];
    public selectedCompany;
    public infoRoute: string = 'detailed-info';
    public showEditReports = false;
    public user$: Observable<IUser> = null;

    private companies$: Observable<Array<ICompany>>;
    private unsubscribe$: Subject<void> = new Subject();
    private currentCompanyId$: Observable<string>;
    private userPermissions$: Observable<IUserPermissions>;

    constructor(
        private store: Store,
        private xuxDrawerSidebarService: XUXDrawerSidebarService,
        private router: Router,
    ) {}

    public ngOnInit() {
        this.user$ = this.store.select(selectUser);
        this.companies$ = this.store.select(selectCompanies);
        this.currentCompanyId$ = this.store.select(selectCompanyId);
        this.userPermissions$ = this.store.select(selectPermissions);

        this.userPermissions$
            .pipe(
                takeUntil(this.unsubscribe$),
                filter((permissions) => !!permissions),
            )
            .subscribe((permissions) => {
                if (permissions.items) {
                    const items = permissions.items;
                    items.forEach((item) => {
                        if (item.name === REPORTING_ADMINISTRATOR_PERMISSION) {
                            this.showEditReports = true;
                        }
                    });
                }
            });

        combineLatest([this.companies$, this.currentCompanyId$])
            .pipe(
                map(([companies, currentCompanyId]) => {
                    this.companies = companies;
                    return companies.find((company) => company.id === currentCompanyId);
                }),
            )
            .subscribe((company) => {
                this.selectedCompany = company;
            });
    }

    public ngOnDestroy() {
        this.unsubscribe$.next();
    }

    public showCompanySelector() {
        this.store.dispatch(show_company_selector());
    }

    public logout() {
        this.xuxDrawerSidebarService.close();
        this.store.dispatch(log_out());
    }

    public editReports() {
        this.router.navigateByUrl('/custom-reports/editor');
    }
}
